export const PREVIEW_STACK_BREAKPOINT_PX = 1400;
export const PREVIEW_FRAME_HEIGHT_SPLIT = 530;
export const PREVIEW_FRAME_HEIGHT_STACKED = 460;
export const PREVIEW_PANE_CHROME_HEIGHT = 50;
